import swal from 'sweetalert2'
import moment from 'moment'
import store from './store'
import _ from 'lodash'
import chroma from 'chroma-js'

export function versaoGitFiltrada (versao) {
  return versao && typeof versao === 'string' && versao.replace(/(\r\n|\n|\r)/gm, '').match(/^v\d+.\d+.\d+-?\w*$/) ? versao : '-'
}

export function ptTimeToMoment (time) { return moment(time, 'YYYY-MM-DDTHH:mm:ss') }

export function generateObjectId () {
  const timestamp = (new Date().getTime() / 1000 | 0).toString(16)
  return timestamp + 'xxxxxxxxxxxxxxxx'.replace(/[x]/g, () => {
    return (Math.random() * 16 | 0).toString(16)
  }).toLowerCase()
}

export function padZeroNumber (number, width = 2, character = '0') {
  number = parseInt(number.toFixed(0))
  number = number + ''
  return number.length >= width ? number : new Array(width - number.length + 1).join(character) + number
}

export function floatToHoursMinsString (number) {
  const { hours, minutes } = floatToHoursMins(number)

  // Fix for negative hours, to be -05:30 instead of -05:-30
  if (hours < 0) {
    return `-${padZeroNumber(hours * -1)}:${padZeroNumber(minutes * -1)}`
  }
  return `${padZeroNumber(hours)}:${padZeroNumber(minutes)}`
}

export function floatToHoursMins (number) {
  const hours = Math.floor(number)
  const minutes = (number % 1) * 60
  return { hours, minutes, float: number }
}

export function inputTimeTofloat (time) {
  if (time.includes('h')) {
    const hours = time.slice(0, -3)
    const minutes = time.slice(-3, -1)
    return parseInt(hours) + (parseInt(minutes) / 100)
  } else {
    const hours = time.slice(0, 2)
    const minutes = time.slice(3, 5)
    return hoursMinsToFloat(hours, minutes)
  }
}

export function hoursMinsToFloat (hours, minutes) {
  return parseInt(hours) + (parseInt(minutes) / 60)
}

export function datetimeToTimeString (datetime) { return datetime.substr(11, 5) }

export function modalDeSucesso (text) {
  if (!text) return
  swal({
    type: 'success',
    text
  })
}

export function modalDeErro (text, title = '') {
  if (!text) return
  swal({
    type: 'error',
    text,
    title
  })
}

export function modalDeInformacao (text) {
  if (!text) return
  swal({
    type: 'info',
    text
  })
}

/**
 * Processa a promise e retorna mensagens personalizadas para cada cenário (success, info, error)
 * @param {Promise} promise
 * @param {Object.<string, string>} messages
 * @returns the request response
 */
export async function processarRequisicaoFinalizandoComModal (promise, messages = {
  success: '',
  error: '',
  info: ''
}) {
  try {
    const response = await promise

    const {body} = response

    if (!body && messages.success) {
      return modalDeSucesso(messages.success || 'Ação executada com sucesso')
    }

    if (!body && messages.info) {
      return modalDeInformacao(messages.info || 'Ação executada com sucesso')
    }

    if (body.success || body.created) {
      return modalDeSucesso(body.success || 'Ação executada com sucesso')
    }
  } catch (e) {
    modalDeErro(e?.body?.error ? e.body.error : messages.error || 'Ocorreu um erro executar sua ação')
    console.log(e)
  }
}

export async function modalDeConfirmacao (params, configDefault = {
  title: '',
  type: 'warning',
  showCancelButton: true,
  confirmButtonClass: 'btn-danger',
  confirmButtonText: 'Confirmar',
  cancelButtonText: 'Cancelar'
}) {
  if (!params.text) return false
  const boleano = await swal({
    title: params.title || configDefault.title,
    text: params.text,
    showCancelButton: true,
    type: configDefault.type,
    confirmButtonClass: configDefault.confirmButtonClass,
    confirmButtonText: params.confirmButtonText || configDefault.confirmButtonText,
    cancelButtonText: params.cancelButtonText || configDefault.cancelButtonText
  })
  return boleano
}

export function getWithDotNotation (model, column, character = '.') {
  // access with string the attributes of objects with dot notation... e.g: {a: {b: true}} = parseColumn(obj, 'a.b')
  return column.split(character).reduce((o, i) => o[i], model)
}

export function formatDateToSend (date) {
  if (moment.isMoment(date)) {
    return date.format('YYYY-MM-DDTHH:mm:ss')
  }
  return moment(date).format('YYYY-MM-DDTHH:mm:ss')
}

export function prettyDate (momentDate) {
  return momentDate.format('DD/MM/YYYY')
}

export function prettyDateTime (momentDate, seconds = true) {
  return seconds ? momentDate.format('DD/MM/YYYY - HH:mm:ss') : momentDate.format('DD/MM/YYYY - HH:mm')
}

export function isInputTimeValid (time, dots = false) {
  let regex
  if (dots) {
    if (time.length !== 5) { return false }
    regex = /^([0-9]|0[0-9]|1?[0-9]|2[0-3]):[0-5]?[0-9]$/
  } else {
    if (time.length !== 4) { return false }
    regex = /^([0-9]|0[0-9]|1?[0-9]|2[0-3])[0-5]?[0-9]$/
  }
  return regex.test(time)
}

export function inputTimeToMoment (time) {
  return moment().set({ hour: time.slice(0, 2), minutes: time.slice(3, 5) })
}

export function resetStateToDefault (state, defaultState) {
  Object.assign(state, defaultState)
}

export function removeDuplicatesArray (arrayOfObjects, key) {
  const tester = []
  const result = []
  arrayOfObjects.forEach(el => {
    if (tester.indexOf(el[key]) === -1) {
      tester.push(el[key])
      result.push(el)
    }
  })
  return result
}

export function getFirstHour (date) {
  if (moment.isMoment(date)) {
    return date.clone().startOf('day')
  }
  return moment(date).startOf('day').toDate()
}

export function getLastHour (date) {
  if (moment.isMoment(date)) {
    return date.endOf('day')
  }
  return moment(date).endOf('day').toDate()
}

export function hasPermission (conditions, userRoles) {
  let isValid = false

  const verifyPermission = (spec, roles) => {
    return (typeof _.find(roles, _.pick(spec, 'module', 'action', 'filter')) !== 'undefined')
  }

  if (!userRoles) {
    userRoles = store.getters.getUserInfo.roles
  }

  const userRolesNames = userRoles.map(r => r.name)

  if (conditions.module) {
    if (conditions.filter) {
      const filters = conditions.filter

      for (let i = 0; i < filters.length; i++) {
        conditions.filter = filters[i]

        isValid = isValid || verifyPermission(conditions, userRoles)
      }
    } else {
      isValid = verifyPermission(conditions, userRoles)
    }
  } else if (conditions.any) {
    for (const role of conditions.any) {
      isValid = userRolesNames.includes(role)
      if (isValid) {
        break
      }
    }
  } else if (conditions.multiple) {
    const rolesUserHasThatIsRequired = []
    for (const role of conditions.any) {
      if (userRolesNames.includes(role)) {
        rolesUserHasThatIsRequired.push(role)
      }
    }
    isValid = rolesUserHasThatIsRequired.length === conditions.multiple.length
  }
  return isValid
}

export function vuexMapDefaultsGetters (stateObject) {
  const result = {}
  _.forIn(stateObject, (value, key) => {
    result[key] = (state) => state[key]
  })
  return result
}

export function vuexMapDefaultsMutations (stateObject) {
  const result = {}
  _.forIn(stateObject, (value, key) => {
    result[key] = (state, payload) => {
      state[key] = payload
    }
  })
  return result
}

export function vuexMapDefaultsActions (stateObject) {
  const result = {}
  _.forIn(stateObject, (value, key) => {
    result[key] = ({ commit }, payload) => {
      commit(key, payload)
    }
  })
  return result
}

export function chunkList (list, chunkSize) {
  const result = list.reduce((ar, it, i) => {
    const ix = Math.floor(i / chunkSize)
    if (!ar[ix]) {
      ar[ix] = []
    }
    ar[ix].push(it)
    return ar
  }, [])
  return result
}

export function mostCommon (array) {
  return _.head(_(array)
    .countBy()
    .entries()
    .maxBy('[1]'))
}

export function rangeDates (startDate, endDate) {
  startDate = moment.isMoment(startDate) ? startDate.toDate() : startDate
  endDate = moment.isMoment(endDate) ? endDate.toDate() : endDate

  const dates = []
  let currentDate = startDate
  const addDays = function (days) {
    const date = new Date(this.valueOf())
    date.setDate(date.getDate() + days)
    return date
  }
  while (currentDate <= endDate) {
    dates.push(currentDate)
    currentDate = addDays.call(currentDate, 1)
  }
  return dates.map(i => moment(i))
}

export function groupBy (data, key) {
  return _.chain(data)
    .groupBy(i => getWithDotNotation(i, key))
    .toPairs()
    .value()
}

export function range (lowEnd, highEnd) {
  if (!Number.isInteger(lowEnd) || !Number.isInteger(highEnd)) {
    throw new Error('Range function of utils received invalid parameters')
  }

  const list = []
  for (let i = lowEnd; i <= highEnd; i++) {
    list.push(i)
  }
  return list
}

export function deepcopy (obj) {
  return JSON.parse(JSON.stringify(obj))
}

export function deepFreeze (o) {
  Object.freeze(o)
  if (o === undefined) {
    return o
  }
  Object.getOwnPropertyNames(o).forEach(function (prop) {
    if (o[prop] !== null && (typeof o[prop] === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) {
      deepFreeze(o[prop])
    }
  })
  return o
}

export function freezeObjects (list) {
  if (!list) return []
  list.forEach(i => {
    deepFreeze(i)
  })
  return list
}

export function parseColorApontamento (apont) {
  let result = 'default'
  if (!apont) { return }
  if (apont.includes('100') || apont.includes('B') || apont.includes('_b')) {
    result = 'warning'
  } else if (apont.includes('C') || apont.includes('Spec') || apont.includes('_c')) {
    result = 'info'
  }
  return result
}

export function orderEmployees (listEmployees, by = 'name', reversed = false) {
  const final = [...listEmployees]
  if (by === 'name') {
    final.sort(function order (a, b) {
      if (a.name < b.name) {
        return -1
      } else if (a.name > b.name) {
        return 1
      }
      return 0
    })
  } else if (by === 'code') {
    final.sort(function order (a, b) {
      return parseInt(a.code) - parseInt(b.code)
    })
  }
  if (reversed) {
    final.reverse()
  }
  return final
}

export function joinBaseDateBaseTime (baseDate, baseTime) {
  // Use when do you have a date without time and you have a date with time
  // baseDate = Date(2018, 5, 5)
  // baseTime = Date(0, 0, 0, 15, 15)
  // returns Date(2018, 5, 5, 15, 15)
  const date = moment(baseDate)
  const time = moment(baseTime)
  date.add(time.date() - 1, 'days')
  date.set({
    hour: time.hours(),
    minute: time.minute()
  })
  return date
}

export function includesSearch (a, b) {
  if (typeof a === 'number') {
    a = a.toString()
  }
  return noSpecialChar(a.toLowerCase()).includes(noSpecialChar(b.toLowerCase()))
}

export function noSpecialChar (text) {
  text = text.toLowerCase()
  text = text.replace(new RegExp('[ÁÀÂÃ]', 'gi'), 'a')
  text = text.replace(new RegExp('[ÉÈÊ]', 'gi'), 'e')
  text = text.replace(new RegExp('[ÍÌÎ]', 'gi'), 'i')
  text = text.replace(new RegExp('[ÓÒÔÕ]', 'gi'), 'o')
  text = text.replace(new RegExp('[ÚÙÛ]', 'gi'), 'u')
  text = text.replace(new RegExp('[Ç]', 'gi'), 'c')
  return text
}

export function validateCnpj (cnpj) {
  /* eslint-disable */
  cnpj = cnpj.replace(/[^\d]+/g,'');

  if(cnpj == '') return false;

  if (cnpj.length != 14)
    return false;

  // Valida DVs
  let tamanho = cnpj.length - 2
  let numeros = cnpj.substring(0,tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(0))
    return false;

  tamanho = tamanho + 1;
  numeros = cnpj.substring(0,tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2)
      pos = 9;
  }
  resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
  if (resultado != digitos.charAt(1))
    return false;

  return true;
  /* eslint-enable */
}

export function validateCpf (cpf) {
  /* eslint-disable */
  cpf = cpf.replace(/[^\d]+/g,'');
  if(cpf == '') return false;

  // Valida 1o digito
  let add = 0;
  for (let i=0; i < 9; i ++)
    add += parseInt(cpf.charAt(i)) * (10 - i);
  let rev = 11 - (add % 11);
  if (rev == 10 || rev == 11)
    rev = 0;
  if (rev != parseInt(cpf.charAt(9)))
    return false;
  // Valida 2o digito
  add = 0;
  for (let i = 0; i < 10; i ++)
    add += parseInt(cpf.charAt(i)) * (11 - i);
  rev = 11 - (add % 11);
  if (rev == 10 || rev == 11)
    rev = 0;
  if (rev != parseInt(cpf.charAt(10)))
    return false;
  return true;
  /* eslint-enable */
}

export async function openElementInFullscreen (elem, onCloseFullScreen) {
  if (elem.requestFullscreen) {
    await elem.requestFullscreen()
  } else if (elem.mozRequestFullScreen) { /* Firefox */
    await elem.mozRequestFullScreen()
  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
    await elem.webkitRequestFullscreen()
  } else if (elem.msRequestFullscreen) { /* IE/Edge */
    await elem.msRequestFullscreen()
  }

  if (document.addEventListener) {
    document.addEventListener('webkitfullscreenchange', exitHandler, false)
    document.addEventListener('mozfullscreenchange', exitHandler, false)
    document.addEventListener('fullscreenchange', exitHandler, false)
    document.addEventListener('MSFullscreenChange', exitHandler, false)
  }

  function exitHandler () {
    if (document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement !== null) {
      onCloseFullScreen()
    }
  }
}

export function closeFullscreen () {
  if (document.exitFullscreen) {
    document.exitFullscreen()
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen()
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen()
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen()
  }
}

export function isostringToMoment (str) {
  return moment(str, 'YYYY-MM-DDTHH:mm:ss')
}

export function dateRangeArray (momentStartDate, momentEndDate) {
  const resultArray = [momentStartDate.clone()]
  const deltaInDays = parseInt(moment.duration(momentEndDate.diff(momentStartDate)).asDays())
  const aux = momentStartDate.clone()
  for (let i = 0; i < deltaInDays; i++) {
    aux.add(1, 'days')
    resultArray.push(moment(aux))
  }
  return resultArray
}

export function round (num, scale) {
  if (!('' + num).includes('e')) {
    return +(Math.round(num + 'e+' + scale) + 'e-' + scale)
  } else {
    const arr = ('' + num).split('e')
    let sig = ''
    if (+arr[1] + scale > 0) {
      sig = '+'
    }
    return +(Math.round(+arr[0] + 'e' + sig + (+arr[1] + scale)) + 'e-' + scale)
  }
}

export function genPalletFromBaseColors (numColors, baseColors) {
  console.assert(baseColors.length !== undefined, 'baseColors must be an Array')

  if (numColors === 1) {
    return baseColors
  }
  const backgroundColors = chroma.scale(baseColors).mode('lab')
  return range(0, numColors)
    .map((i, index) => backgroundColors(index / (numColors - 1)).hex())
}

export function getUserInfo (persistentKey) {
  try {
    return JSON.parse(window.localStorage.getItem(persistentKey)).userInfo
  } catch (e) {
    return {}
  }
}

export function getEmployeeTimesheetDateRange (day, closingDate) {
  // Get the range of dates on employee timesheet

  let dateStart

  day = moment.isMoment(day) ? day : moment(day)

  // start
  if (day.date() < closingDate) {
    dateStart = day.clone().subtract(1, 'month')
    dateStart = dateStart.set('date', closingDate)
  } else {
    dateStart = day.clone().set('date', closingDate)
    dateStart = moment(getFirstHour(dateStart))
  }

  // end
  const endDate = dateStart.clone().add(1, 'months')
  const dateEnd = getLastHour(endDate).subtract(1, 'days')

  return { startDate: dateStart, endDate: dateEnd }
}

export function ensureIsDate (date) {
  return moment.isMoment(date) ? date.toDate() : date
}

export function rightJourneyTextAndColor (journey) {
  const colors = {
    'default': '#f5f5f5',
    'danger': '#ff6955',
    'success': '#0c9b73',
    'info': '#00a2b5',
    'warning': '#ffcb55',
    'primary': '#2c3e50'
  }
  const start = moment(journey.start)
  const end = moment(journey.end)

  let text = `${start.format('HH:mm')} - ${end.format('HH:mm')}`

  if (start.isSame(end)) {
    text = journey.name
  }
  return {
    text,
    color: colors[journey.color]
  }
}

export function validatePermission (module, action) {
  // use this function as a decorator in methods that you wanna
  // validate the prop AllowedActions of the component

  return function (target, key, descriptor) {
    const original = descriptor.value
    descriptor.value = function () {
      if (hasPermission({ module, action })) {
        return original.apply(this, arguments)
      }
    }
  }
}

export function getPhaseForDate (routineStartDateMoment, journeyLen, dateWantedMoment, extraPhaseShift = 0) {
  routineStartDateMoment = routineStartDateMoment.startOf('day')
  dateWantedMoment = dateWantedMoment.startOf('day')
  const diffAsDays = dateWantedMoment.diff(routineStartDateMoment, 'days')
  if (diffAsDays < 0) {
    console.error('EITA! getPhaseForDate recebeu um diff negativo')
  }
  return ((diffAsDays % journeyLen) + extraPhaseShift) % journeyLen
}

// addEventListener support for IE8
export function bindEvent (element, eventName, eventHandler) {
  if (element.addEventListener) {
    element.addEventListener(eventName, eventHandler, false)
  } else if (element.attachEvent) {
    element.attachEvent('on' + eventName, eventHandler)
  }
}

export function executeShortcut (event, actions) {
  // event is a Keyboard event
  // actions must be a object where the key is the shortcut and the value a function
  // example of action:
  // {
  //    // you can use a | to have multiple shortcuts for the same function
  //    'esc|i': () => { alert('oii') },
  //    // to use ctrl and shift always use they in the following worder => [shift, ctrl]
  //    'i+ctrl': () => alert('vai filhao'),
  // }

  const friendlyKeys = {
    'Escape': 'esc',
    'ArrowUp': 'up',
    'ArrowDown': 'down',
    'ArrowRight': 'right',
    'ArrowLeft': 'left',
    'Tab': 'tab'
  }

  const key = friendlyKeys[event.key] || event.key.toLowerCase()
  const ctrl = event.ctrlKey
  const shift = event.shiftKey

  let shortcut = key
  if (shift) { shortcut = shortcut + '+shift' }
  if (ctrl) { shortcut = shortcut + '+ctrl' }

  let executedShortcut = false

  Object.keys(actions).forEach(s => {
    const ors = s.split('|')
    if (ors.find(i => i === shortcut)) {
      actions[s](event)
      executedShortcut = true
    }
  })

  return {executedShortcut}
}

export function runMultipleFuncsInParallel (listOfAsyncFunctions, limitParallel) {
  async function doWork (iterator) {
    /* eslint-disable */
    for (let [index, func] of iterator) {
      await func()
    }
    /* eslint-enable */
  }

  const workers = new Array(limitParallel).fill(listOfAsyncFunctions.entries()).map(doWork)

  return Promise.all(workers)
}

export function getHierarchy (region, regions) {
  const h = []

  if (region && (!_.isEmpty(region))) {
    h.push(region)

    let currentParent = region.parent

    while (currentParent && (currentParent !== '')) {
      const parent = _.find(regions, {id: currentParent})
      h.unshift(parent)

      if (_.has(parent, 'parent')) {
        currentParent = parent.parent
      } else {
        currentParent = ''
      }
    }
  }

  return h
}

export function getHierarchyName (region, regions) {
  const h = getHierarchy(region, regions)

  if (h.length) {
    let hName = h[0].name
    for (let i = 1; i < h.length; i++) {
      hName = hName + ' / ' + h[i].name
    }
    return hName
  }
}

export function getTagsFromOneWithParent (tag, regions) {
  if (!regions || !regions.length) { return [] }
  const parents = []
  let currentParent = tag.parent

  while (currentParent) {
    const parent = _.find(regions, {id: currentParent})
    parents.unshift(parent)
    currentParent = parent.parent
  }
  parents.push(tag)
  return parents.map(item => ({...item, text: item.name || item.text}))
}

export function setCharAt (str, index, chr) {
  if (index > str.length - 1) return str
  return str.substring(0, index) + chr + str.substring(index + 1)
}

export function formatString24Hours (input) {
  let correctInput = input

  if (Number(correctInput[0]) > 2) {
    correctInput = setCharAt(correctInput, 0, '2')
  }
  if (Number(correctInput[0]) === 2 && Number(correctInput[1]) > 3) {
    correctInput = setCharAt(correctInput, 1, '3')
  }
  if (Number(correctInput[3]) > 5) {
    correctInput = setCharAt(correctInput, 3, '5')
  }

  return correctInput
}

export async function pegarJornada () {
  await store.dispatch('common/journeys/fetchItems')
  const loadedJourneys = store.state.common.journeys.items
  const firstWork = loadedJourneys.find(i => i.kind === 0)
  const folga = loadedJourneys.find(i => i.name.includes('Folga'))

  return [firstWork, folga]
}

export function escalaEstaValida (jornadaDeTrabalho, jornadaDeFolga) {
  if (jornadaDeTrabalho && jornadaDeFolga) {
    if (jornadaDeTrabalho.kind === 0 && jornadaDeFolga.name.includes('Folga')) {
      return true
    }
  }
  return false
}

export function montarEscala (firstWork, folga) {
  const escalaMontada = [firstWork, firstWork, firstWork, firstWork, firstWork, folga, folga]

  return escalaMontada
}

export async function adicionarNovaInvalida () {
  const [jornadaDeTrabalho, jornadaDeFolga] = await pegarJornada()
  if (!escalaEstaValida(jornadaDeTrabalho, jornadaDeFolga)) {
    return true
  }
  return false
}

export async function erroAdicionarNovaEscala (erro) {
  if (await erro) {
    modalDeErro('Para continuar com esta operação é necessário que existam jornadas cadastradas no sistema')
  }
}
